import React from 'react';
import { Box, Container, Grid, Typography, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

function Mentorship() {
    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: '#1f1f1f',
                pt: 6,
                pb: 3,
            }}
        >
            <Container maxWidth="lg">
                <Grid container alignItems="center" spacing={4}>

                    {/* Content Section */}
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ color: 'white', textAlign: 'left' }}>
                            {/* Subtitle */}
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: '#1e88e5', // Blue color for subtitle
                                    fontWeight: 'bold',
                                    mb: 1,
                                }}
                            >
                                Empower Through Mentorship
                            </Typography>

                            {/* Heading */}
                            <Typography
                                variant="h2"
                                sx={{
                                    fontSize: '32px',
                                    fontWeight: '600',
                                    mb: 2,
                                }}
                            >
                                Learn, Grow, and Excel
                            </Typography>

                            {/* Paragraph */}
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    mb: 2,
                                }}
                            >
                                Join our mentorship program to connect with experienced industry leaders who are committed to guiding you in your journey of personal and professional growth.
                            </Typography>

                            {/* Bullet List */}
                            <List>
                                <ListItem sx={{ py: 0 }}>
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        <CircleIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Access one-on-one mentorship sessions."
                                        primaryTypographyProps={{ color: 'rgba(255, 255, 255, 0.85)' }}
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0 }}>
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        <CircleIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Gain insights from industry leaders."
                                        primaryTypographyProps={{ color: 'rgba(255, 255, 255, 0.85)' }}
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0 }}>
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        <CircleIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Learn best practices for career advancement."
                                        primaryTypographyProps={{ color: 'rgba(255, 255, 255, 0.85)' }}
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0 }}>
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        <CircleIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Build your network of professionals and peers."
                                        primaryTypographyProps={{ color: 'rgba(255, 255, 255, 0.85)' }}
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0 }}>
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        <CircleIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Develop actionable plans for success."
                                        primaryTypographyProps={{ color: 'rgba(255, 255, 255, 0.85)' }}
                                    />
                                </ListItem>
                            </List>
                        </Box>
                    </Grid>

                    {/* Image Section */}
                    <Grid item xs={12} sm={6}>
                        <Box
                            component="img"
                            src="/img/mentorship.jpg" // Replace with actual image path
                            alt="Mentorship Program"
                            sx={{
                                width: '100%',
                                borderRadius: 2,
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default Mentorship;
